import { Button, Table,Spin, Modal, Form, Input, InputNumber} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import {AUTH_URL} from '../constants';
import {IInstallmentPeriod, IPaymentPeriod} from '../factory/interfaces'
import { IoEnterSharp } from "react-icons/io5"
import { notify, notify_success, toastStyle } from '../pages/LoginPage';
import { selectUserDetails } from '../features/auth/authSlice';
import { useSelector } from 'react-redux';


const InstallmentPeriodsTable = () => {
    const dispatch = useDispatch()
    const [showExpenseForm, setShowExpenseForm] = useState(false)
    const [addingExpense, setAddingExpense] = useState(false)
    const [reloadComponent, setReloadComponent] = useState(false)
    const [installmentPeriods, setIstallmentPeriods] = useState<IInstallmentPeriod[]>()

    const [form] = Form.useForm()
  

     //Redux states
    const userDetails = useSelector(selectUserDetails)
    const isAdmin = userDetails?.role === 'admin'
    const metadata = useSelector((state: any) => state.metadata)

    //Functions

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Number of days',
    dataIndex: 'number_of_days',
    key: 'number_of_days',
  },
  {
    title: 'Date of creation',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },

];

  const handleClose = ()=>{
    setShowExpenseForm(false)
    form.resetFields()
    }
  const showForm = ()=>setShowExpenseForm(true)


    const getInstallmentPeriods = async()=>{
      const response = await axios.get(`${AUTH_URL}/meta/installment-periods`, {withCredentials: true})
      if(response.data.success){
        setIstallmentPeriods(response.data.installment_periods)
      }

    }

    const registerPaymentPeriod = async()=>{
      setAddingExpense(true)
      const expenseData = {
        name: form.getFieldValue('name'),
        number_of_days: form.getFieldValue('number_of_days'),
      }
      const response = await axios.post(`${AUTH_URL}/meta/installment-periods`, expenseData, {withCredentials: true})
      setAddingExpense(false)
      if(response.data.success){
        notify_success(`${response.data.message}`, toastStyle)
        form.resetFields()
        handleClose()
        setReloadComponent(true)
      }else{
        notify(`${response.data.message}`, toastStyle)

      }
    }


  useEffect(()=>{
    if(reloadComponent){
        getInstallmentPeriods()
        setReloadComponent(false)
    }
}, [reloadComponent])

  useEffect(()=>{
    getInstallmentPeriods()

  }, [dispatch])


  return (
    <>
    {installmentPeriods? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         </Col>
         <Col className='text-end py-2'>
            <Button type='primary' onClick={showForm} className='rounded-0 mx-1 text-uppercase small'> <IoEnterSharp style={{marginRight: '5px'}} /> <span>Register Installment Period</span></Button>
         </Col>
        </Row>
    
     {
      installmentPeriods &&
      <Table pagination={false} className='rounded-0 transactions-table' id='dlms-expenses-data' bordered dataSource={installmentPeriods} columns={columns} 
       />
     }
     
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading installment periods..." size="large">
        <div className="content" />
      </Spin>

    }
   
      <Modal
      width={600} open={showExpenseForm} onCancel={handleClose}
         title={`REGISTER NEW INSTALLMENT PERIOD`}
         centered
         footer={[
                     [

                      ]
                ]}
      >
      <Form
          layout="vertical"
          form={form}
          onFinish={registerPaymentPeriod}

          >
          <Form.Item 
          label="Name"
          name="name"
          rules={[{ required: true, message: "Name is required" }]}
          tooltip='Name of the payment period. E.g. DAILY, WEEKLY, MONTHLY'
          >
              <Input placeholder='Enter name' style={{width: '100%'}} className='rounded-0'
                />
          </Form.Item>
          <Form.Item 
            label='Number of days'
            name='number_of_days'
            rules={[{ required: true, message: "Number of days is required" }]}
            tooltip='Provide the number of days. Eg. 30'

          >
          <InputNumber min={1} style={{width: '100%'}} className='rounded-0'/>
          </Form.Item>
          <Row className='d-flex gap-4' style={{marginTop: '40px'}}>
          <Col className='d-flex'>
          <Button loading={addingExpense} htmlType="submit" type='primary' className='rounded-0 text-uppercase small' key="edit_user">
              <span><SaveOutlined style={{marginRight: '5px'}} /></span>
              
              {
              addingExpense ?
              'Registering Installment Period...'
              :
              'Register Installment Period'
              
              }
          </Button>
          <Button  className='rounded-0 small text-uppercase mx-3' key="cancel" onClick={handleClose}>
            <CloseOutlined />   Cancel
          </Button>
          
          </Col>
          </Row>
          
        </Form>
      </Modal>
    </>
  )
}

export default InstallmentPeriodsTable